import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { AgendamentoProvider } from './agendamento';
import { AgendaProvider } from './agenda';
import { CategoriaProvider } from './categoria';
import { FormaPagamentoProvider } from './formapagamento';
import { PerfilProvider } from './perfil';
import { MedicoProvider } from './medico';
import { ClinicaProvider } from './clinica';
import { ChatProvider } from './chat';
import { ModeloProvider } from './modelo';
import { NotaFiscalProvider } from './notafiscal';
import { GrupoExameProvider } from './grupoExames';
import { BeneficioProvider } from './beneficio';
import { ProcedimentoProvider } from './procedimentos';
import { ReceitaProvider } from './receita';
import { VideoConferenceProvider } from './videoConference';

const AppProvider: React.FC = ({ children }) => (
  <VideoConferenceProvider>
    <ToastProvider>
      <ClinicaProvider>
        <AuthProvider>
          <ChatProvider>
            <CategoriaProvider>
              <FormaPagamentoProvider>
                <PerfilProvider>
                  <GrupoExameProvider>
                    <MedicoProvider>
                      <AgendaProvider>
                        <AgendamentoProvider>
                          <NotaFiscalProvider>
                            <BeneficioProvider>
                              <ModeloProvider>
                                <ProcedimentoProvider>
                                  <ReceitaProvider>{children}</ReceitaProvider>
                                </ProcedimentoProvider>
                              </ModeloProvider>
                            </BeneficioProvider>
                          </NotaFiscalProvider>
                        </AgendamentoProvider>
                      </AgendaProvider>
                    </MedicoProvider>
                  </GrupoExameProvider>
                </PerfilProvider>
              </FormaPagamentoProvider>
            </CategoriaProvider>
          </ChatProvider>
        </AuthProvider>
      </ClinicaProvider>
    </ToastProvider>
  </VideoConferenceProvider>
);

export default AppProvider;
